import { InitComponentStateType, createComponentState } from '@/state';

import { SortDirectionEnum } from '@/models/gen/graphql';

export enum UserSortColumnEnum {
  username = 'username',
  firstName = 'firstName',
  email = 'email',
  lastLoginUtc = 'lastLoginUtc',
  employeeId = 'employeeId',
  active = 'active',
}

export type UsersTableState = {
  sorting: {
    column: UserSortColumnEnum | undefined;
    direction: SortDirectionEnum | undefined;
  };
  onSort: (column: UserSortColumnEnum) => void;
};

export const initUsersTableState: InitComponentStateType<UsersTableState> = (set): UsersTableState => ({
  sorting: { column: undefined, direction: undefined },
  onSort: (column: UserSortColumnEnum): void => {
    set((current: UsersTableState): UsersTableState => {
      const isSameColumn = current.sorting.column === column;
      let direction: SortDirectionEnum | undefined;
      if (!isSameColumn) direction = SortDirectionEnum.Asc;
      else if (current.sorting.direction === SortDirectionEnum.Asc) direction = SortDirectionEnum.Desc;
      else direction = undefined;
      return { ...current, sorting: { column: direction ? column : undefined, direction } };
    });
  },
});

const useUsersTableState = createComponentState(initUsersTableState);

export default useUsersTableState;
